var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { isNumber } from 'lodash';
import { perFacadeApi } from 'helpers/api.helper';
export var getAllShadowHealthCourses = function (instructorId) {
    if (instructorId) {
        return perFacadeApi.get("/shadowhealth/allCourses/byInstructorId?instructorId=".concat(instructorId));
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getShadowHealthCourseSummaryResponse = function (courseId, courseSectionId) {
    if (courseSectionId) {
        return perFacadeApi.get("/shadowhealth/courseSummary/".concat(courseId, "?courseSectionId=").concat(courseSectionId));
    }
    return perFacadeApi.get("/shadowhealth/courseSummary/".concat(courseId));
};
export var getShadowHealthAssignmentSummary = function (assignmentId, courseSectionId, contentType) {
    if (assignmentId) {
        if (courseSectionId) {
            return perFacadeApi.get("/shadowhealth/assignmentSummary/".concat(assignmentId, "?courseSectionId=").concat(courseSectionId, "&contentType=").concat(contentType));
        }
        return perFacadeApi.get("/shadowhealth/assignmentSummary/".concat(assignmentId, "?contentType=").concat(contentType));
    }
    return Promise.resolve({
        data: {
            data: [],
            fallbackMessage: null
        }
    });
};
export var buildCourseDropdownOptions = function (courses) {
    var data = [{ name: '', value: '-1', hidden: true }];
    courses.forEach(function (course) {
        data.push({ name: course.courseName, value: "".concat(course.courseId), hidden: false });
    });
    return data;
};
export var buildSectionDropdownOptions = function (sections) {
    var data = [{ name: '', value: '-1', hidden: true }];
    sections.forEach(function (_a) {
        var sectionName = _a.sectionName, _b = _a.sectionId, sectionId = _b === void 0 ? 0 : _b;
        data.push({ name: sectionName, value: "".concat(sectionId), hidden: false });
    });
    return data;
};
export var getStudentPerformanceReports = function (courseId, courseSectionId) {
    if (courseId) {
        if (courseSectionId) {
            return perFacadeApi.get("/shadowhealth/studentPerformance/".concat(courseId, "?courseSectionId=").concat(courseSectionId));
        }
        return perFacadeApi.get("/shadowhealth/studentPerformance/".concat(courseId));
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getCategoryStrengthsAndWeaknesses = function (courseId, categories, courseSectionId) {
    if (courseId) {
        if (courseSectionId) {
            return perFacadeApi.get("/shadowhealth/categoryStrengthAndWeakness/".concat(courseId, "?courseSectionId=").concat(courseSectionId, "&categoryTypePickList=").concat(categories.join(',')));
        }
        return perFacadeApi.get("/shadowhealth/categoryStrengthAndWeakness/".concat(courseId, "?categoryTypePickList=").concat(categories.join(',')));
    }
    return Promise.resolve({ data: { data: null, fallbackMessage: null } });
};
export var getStudentEngagementReports = function (courseId, courseSectionId) {
    if (courseId) {
        if (courseSectionId) {
            return perFacadeApi.get("/shadowhealth/studentEngagement/".concat(courseId, "?courseSectionId=").concat(courseSectionId));
        }
        return perFacadeApi.get("/shadowhealth/studentEngagement/".concat(courseId));
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getStudentAssignmentPerformanceReports = function (studentId, courseId, courseSectionId) {
    if (studentId && courseId) {
        var baseUrl = "/shadowhealth/student/".concat(studentId, "/course/").concat(courseId, "/performance");
        var params = new URLSearchParams();
        if (courseSectionId) {
            params.set('courseSectionId', courseSectionId.toString());
        }
        return perFacadeApi.get("".concat(baseUrl, "?").concat(params.toString()));
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getStudentProfileSummaryReports = function (studentId, courseId) {
    if (studentId) {
        var baseUrl = "/shadowhealth/studentSummary/".concat(studentId);
        var params = new URLSearchParams();
        if (courseId) {
            params.set('courseId', courseId.toString());
        }
        return perFacadeApi.get("".concat(baseUrl, "?").concat(params.toString()));
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getStudentAssignmentViewSummaryReports = function (assignmentId, courseId, courseSectionId) {
    if (assignmentId) {
        var baseUrl = "/shadowhealth/assignmentViewSummary/".concat(assignmentId);
        var params = new URLSearchParams();
        if (courseId) {
            params.set('courseId', courseId.toString());
        }
        if (courseSectionId) {
            params.set('courseSectionId', courseSectionId.toString());
        }
        return perFacadeApi.get("".concat(baseUrl, "?").concat(params.toString()));
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getSHUsersFromEvolveUsername = function (evolveUsername) {
    if (evolveUsername) {
        return perFacadeApi.get("/shadowhealth/evolveuser/".concat(evolveUsername));
    }
    return Promise.resolve({ data: { data: [] } });
};
export var getAssignmentDetailStudentPerformanceReports = function (assignmentId, courseId, courseSectionId) {
    if (assignmentId) {
        var baseUrl = "/shadowhealth/assignment/".concat(assignmentId, "/performance");
        var params = new URLSearchParams();
        if (courseId) {
            params.set('courseId', courseId.toString());
        }
        if (courseSectionId) {
            params.set('courseSectionId', courseSectionId.toString());
        }
        return perFacadeApi.get("".concat(baseUrl, "?").concat(params.toString()));
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getAssignmentDetailStudentEngagementReports = function (assignmentId, courseSectionId) {
    if (!assignmentId) {
        return Promise.resolve({ data: { data: [], fallbackMessage: null } });
    }
    var baseUrl = "/shadowhealth/assignment/".concat(assignmentId, "/engagement");
    var params = new URLSearchParams();
    if (courseSectionId) {
        params.set('courseSectionId', courseSectionId.toString());
    }
    return perFacadeApi.get("".concat(baseUrl, "?").concat(params.toString()));
};
export var getAllAssignments = function (courseId, courseSectionId) {
    if (courseId) {
        if (courseSectionId) {
            return perFacadeApi.get("/shadowhealth/allAssignments/course/".concat(courseId, "?courseSectionId=").concat(courseSectionId));
        }
        return perFacadeApi.get("/shadowhealth/allAssignments/course/".concat(courseId));
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getStudentAssignmentEngagementReports = function (studentId, courseId, courseSectionId) {
    if (studentId && courseId) {
        var baseUrl = "/shadowhealth/student/".concat(studentId, "/course/").concat(courseId, "/engagement");
        var params = new URLSearchParams();
        if (courseSectionId) {
            params.set('courseSectionId', courseSectionId.toString());
        }
        return perFacadeApi.get("".concat(baseUrl, "?").concat(params.toString()));
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getAllSHStudentsByCourseId = function (courseId, courseSectionId) {
    if (courseId) {
        var baseUrl = "/shadowhealth/allStudents/".concat(courseId);
        var params = new URLSearchParams();
        if (courseSectionId) {
            params.set('courseSectionId', courseSectionId.toString());
        }
        return perFacadeApi.get("".concat(baseUrl, "?").concat(params.toString()));
    }
    return Promise.resolve({ data: { data: {}, fallbackMessage: null } });
};
export var getSHCourseAggregateReports = function (instructorId) {
    if (instructorId) {
        return perFacadeApi.get("/shadowhealth/courseAggregates/".concat(instructorId));
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getEducationOpportunities = function (courseId, courseSectionId) {
    if (courseId) {
        var baseUrl = "/shadowhealth/educationOpportunities/".concat(courseId);
        var params = new URLSearchParams();
        if (courseSectionId) {
            params.set('courseSectionId', courseSectionId.toString());
        }
        return perFacadeApi.get("".concat(baseUrl, "?").concat(params.toString()));
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getEmpathyOpportunities = function (courseId, courseSectionId) {
    if (courseId) {
        var baseUrl = "/shadowhealth/empathyOpportunities/".concat(courseId);
        var params = new URLSearchParams();
        if (courseSectionId) {
            params.set('courseSectionId', courseSectionId.toString());
        }
        return perFacadeApi.get("".concat(baseUrl, "?").concat(params.toString()));
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getCarePlanRootsReports = function (courseId, courseSectionId) {
    if (courseId) {
        var baseUrl = "/shadowhealth/carePlanRoots/".concat(courseId);
        var params = new URLSearchParams();
        if (courseSectionId) {
            params.set('courseSectionId', courseSectionId.toString());
        }
        return perFacadeApi.get("".concat(baseUrl, "?").concat(params.toString()));
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getCarePlanChildrenReports = function (courseId, parentId, courseSectionId) {
    if (courseId) {
        var baseUrl = "/shadowhealth/carePlanChildren/".concat(courseId);
        var params = new URLSearchParams();
        if (parentId) {
            params.set('parent', parentId.toString());
        }
        if (courseSectionId) {
            params.set('courseSectionId', courseSectionId.toString());
        }
        return perFacadeApi.get("".concat(baseUrl, "?").concat(params.toString()));
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getCarePlanCount = function (courseId, courseSectionId) {
    if (courseId) {
        var baseUrl = "/shadowhealth/carePlanCounts/".concat(courseId);
        var params = new URLSearchParams();
        if (courseSectionId) {
            params.set('courseSectionId', courseSectionId.toString());
        }
        return perFacadeApi.get("".concat(baseUrl, "?").concat(params.toString()));
    }
    return Promise.resolve({ data: { data: {}, fallbackMessage: null } });
};
export var getOpportunitiesStudentsReports = function (_a) {
    var isEducation = _a.isEducation, courseId = _a.courseId, opportunity = _a.opportunity, courseSectionId = _a.courseSectionId, offset = _a.offset, limit = _a.limit, sortby = _a.sortby, desc = _a.desc;
    if (courseId) {
        var baseUrl = "/shadowhealth/".concat(isEducation ? 'educationOpportunitiesStudents' : 'empathyOpportunitiesStudents', "/").concat(courseId);
        var params = new URLSearchParams(__assign(__assign(__assign(__assign(__assign(__assign({}, (courseSectionId && { courseSectionId: courseSectionId.toString() })), (opportunity && { opportunity: opportunity })), (isNumber(offset) && { offset: offset.toString() })), (limit && { limit: limit.toString() })), (sortby && { sortby: sortby.toString() })), (desc && { desc: desc.toString() })));
        return perFacadeApi.get("".concat(baseUrl, "?").concat(params.toString()));
    }
    return Promise.resolve({ data: { data: {}, fallbackMessage: null } });
};
export var getEducationEmpathyCounts = function (courseId, courseSectionId) {
    if (courseId) {
        var baseUrl = "/shadowhealth/educationEmpathyCounts/".concat(courseId);
        var params = new URLSearchParams();
        if (courseSectionId) {
            params.set('courseSectionId', courseSectionId.toString());
        }
        return perFacadeApi.get("".concat(baseUrl, "?").concat(params.toString()));
    }
    return Promise.resolve({ data: { data: {}, fallbackMessage: null } });
};
export var getCPRASummary = function (assignmentId) {
    if (assignmentId) {
        var baseUrl = "/shadowhealth/cpra/cpraOverall/cpraSummary/".concat(assignmentId);
        return perFacadeApi.get(baseUrl);
    }
    return Promise.resolve({ data: { data: {}, fallbackMessage: null } });
};
export var getCPRAClassDistribution = function (assignmentId) {
    if (assignmentId) {
        var baseUrl = "/shadowhealth/cpra/cpraOverall/classDistribution/".concat(assignmentId);
        return perFacadeApi.get(baseUrl);
    }
    return Promise.resolve({ data: { data: {}, fallbackMessage: null } });
};
export var getCPRAStudentsBelowProficient = function (assignmentId) {
    if (assignmentId) {
        var baseUrl = "/shadowhealth/cpra/cpraOverall/studentsBelowProficient/".concat(assignmentId);
        return perFacadeApi.get(baseUrl);
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getCPRAClassConstructSummary = function (assignmentId) {
    if (assignmentId) {
        var baseUrl = "/shadowhealth/cpra/cpraOverall/classConstructSummary/".concat(assignmentId);
        return perFacadeApi.get(baseUrl);
    }
    return Promise.resolve({ data: { data: {}, fallbackMessage: null } });
};
export var getCPRATable = function (assignmentId) {
    if (assignmentId) {
        var baseUrl = "/shadowhealth/cpra/cpraTable/".concat(assignmentId);
        return perFacadeApi.get(baseUrl);
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getCPRAStudentResults = function (evolveUser, assignmentId) {
    var baseUrl = "/shadowhealth/cpra/studentResults?evolveUsername=".concat(evolveUser);
    if (assignmentId) {
        baseUrl = "/shadowhealth/cpra/studentResults?evolveUsername=".concat(evolveUser, "?&assignmentId=").concat(assignmentId);
    }
    return perFacadeApi.get(baseUrl);
};
export var getCPRAAssignments = function (evolveUsername) {
    return perFacadeApi.get("/shadowhealth/cpra/cpraAssignments?evolveUsername=".concat(evolveUsername));
};
export var getCJMMOverall = function (courseId) {
    if (courseId) {
        var baseUrl = "/shadowhealth/cjmmCourseLevel/cjmmOverall/".concat(courseId);
        return perFacadeApi.get(baseUrl);
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getCJMMClassAssignmentView = function (courseId) {
    if (courseId) {
        var baseUrl = "/shadowhealth/cjmmCourseLevel/classAssignmentView/".concat(courseId);
        return perFacadeApi.get(baseUrl);
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getCJMMAssignmentTableRecords = function (courseId, constructId) {
    if (courseId && constructId) {
        var baseUrl = "/shadowhealth/cjmmCourseLevel/classAssignmentView/".concat(courseId, "/").concat(constructId);
        return perFacadeApi.get(baseUrl);
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getCJMMStudentListView = function (courseId) {
    if (courseId) {
        var baseUrl = "/shadowhealth/cjmmCourseLevel/studentListView/".concat(courseId);
        return perFacadeApi.get(baseUrl);
    }
    return Promise.resolve({ data: { data: [], fallbackMessage: null } });
};
export var getCJMMCardDetails = function (courseId, constructId, offset, limit) {
    if (courseId) {
        var baseUrl = "/shadowhealth/cjmmCourseLevel/classAssignmentView/".concat(courseId, "/students");
        var params = new URLSearchParams(__assign(__assign(__assign({}, (constructId && { construct: constructId })), (isNumber(offset) && { offset: offset.toString() })), (limit && { limit: limit.toString() })));
        return perFacadeApi.get("".concat(baseUrl, "?").concat(params.toString()));
    }
    return Promise.resolve({ data: { data: {}, fallbackMessage: null } });
};
export var fetchCJMMSHAssignments = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch('/sh-assignment-cjmm')];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var getInstructorsByStudentId = function (studentId) {
    var params = new URLSearchParams();
    var baseUrl = '/shadowhealth/instructors/byStudentId';
    if (studentId) {
        params.append('studentId', studentId);
        return perFacadeApi.get("".concat(baseUrl, "?").concat(params));
    }
    return Promise.resolve({ data: { data: {}, fallbackMessage: null } });
};
